import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { configurationBillableConceptService } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.service'
import { CrudModelPaginatorLaboratory, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefBillableConceptGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.concept'),
            field: 'name',
            minWidth: 250,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.group'),
            field: 'group.name',
            minWidth: 150,
            flex: 1,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.groupCode'),
            field: 'group.code',
            minWidth: 150,
            flex: 1,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export enum ConfigurationBillableConceptsGridSidepanelComboElements {
    BILLABLE_RATES = 1
}

export interface BillableConceptGridState extends CrudModelPaginatorLaboratory<ConfigurationBillableConceptResponse> {
    showSidepanel: boolean
    sidepanelTitle: string
}
export const initialBillableConceptGridState =
    (): BillableConceptGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.accounting.billableconcept',
        columnsDef: columnsDefBillableConceptGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationBillableConceptService, store.getters.labId),
        showSidepanel: false,
        sidepanelTitle: ''
    })
